import { IOrganisation } from '@bciti/types';
import { createAction, props } from '@ngrx/store';
import { BcitiEnvironment } from 'src/app/interfaces/store/store.interface';

export const ClearGlobalStateAction = createAction('[Global] - Clear Global State');

export const SetEnvironmentAction = createAction('[Global] - Set Environment', props<{ environment: BcitiEnvironment }>());

export const SetOrganisationsAction = createAction('[Global] - Set Organisations', props<{ organisations: Partial<IOrganisation>[] }>());

export const GetOrganisationsAction = createAction('[Global] - Get Organisations');

export const GetOrganisationsSucessAction = createAction('[Global] - Get Organisations Sucess');

export const GetOrganisationsErrorAction = createAction('[Global] - Get Organisations Error', props<{ error: any }>());
